var exports = {
  "tb": "UserProfileModal.module__noteTextarea___Q3NVdz",
  "CR": "UserProfileModal.module__modalRoot___Q3NVdz",
  "eF": "UserProfileModal.module__userInfo___Q3NVdz",
  "hR": "UserProfileModal.module__userInfoHeader___Q3NVdz",
  "hA": "UserProfileModal.module__userInfoHeaderDesktop___Q3NVdz",
  "Rn": "UserProfileModal.module__userInfoContent___Q3NVdz",
  "yn": "UserProfileModal.module__profileDataWarning___Q3NVdz",
  "S7": "UserProfileModal.module__nameRow___Q3NVdz",
  "nT": "UserProfileModal.module__userName___Q3NVdz",
  "a1": "UserProfileModal.module__userTag___Q3NVdz",
  "Fj": "UserProfileModal.module__usernameRow___Q3NVdz",
  "hI": "UserProfileModal.module__pronouns___Q3NVdz",
  "sM": "UserProfileModal.module__srOnly___Q3NVdz",
  "Li": "UserProfileModal.module__customStatusText___Q3NVdz",
  "Ef": "UserProfileModal.module__customStatusRow___Q3NVdz",
  "_z": "UserProfileModal.module__tagBadgeRow___Q3NVdz",
  "U3": "UserProfileModal.module__badgesWrapper___Q3NVdz",
  "ZV": "UserProfileModal.module__userNoteEditor___Q3NVdz",
  "xu": "UserProfileModal.module__noteLabel___Q3NVdz",
  "_j": "UserProfileModal.module__noteTextareaBase___Q3NVdz",
  "jd": "UserProfileModal.module__noteTextareaEditing___Q3NVdz",
  "EN": "UserProfileModal.module__noteTextareaNotEditing___Q3NVdz",
  "bs": "UserProfileModal.module__profileContent___Q3NVdz",
  "EM": "UserProfileModal.module__profileContentHeader___Q3NVdz",
  "cI": "UserProfileModal.module__bannerContainer___Q3NVdz",
  "HG": "UserProfileModal.module__bannerMask___Q3NVdz",
  "_e": "UserProfileModal.module__bannerImage___Q3NVdz",
  "N1": "UserProfileModal.module__headerContainer___Q3NVdz",
  "H": "UserProfileModal.module__avatarContainer___Q3NVdz",
  "fc": "UserProfileModal.module__actionButtonsContainer___Q3NVdz",
  "hQ": "UserProfileModal.module__contentContainer___Q3NVdz",
  "sq": "UserProfileModal.module__profileContentWrapper___Q3NVdz",
  "zL": "UserProfileModal.module__scrollerFullHeight___Q3NVdz",
  "jT": "UserProfileModal.module__modalContainer___Q3NVdz",
  "uu": "UserProfileModal.module__actionButtons___Q3NVdz",
  "iA": "UserProfileModal.module__buttonIcon___Q3NVdz",
  "ro": "UserProfileModal.module__menuIcon___Q3NVdz",
  "WB": "UserProfileModal.module__avatarFocusRing___Q3NVdz",
  "VS": "UserProfileModal.module__tabsWrapper___Q3NVdz",
  "OT": "UserProfileModal.module__mutualFriendsList___Q3NVdz",
  "Z8": "UserProfileModal.module__mutualSectionDivider___Q3NVdz",
  "KF": "UserProfileModal.module__mutualFriendItem___Q3NVdz",
  "vu": "UserProfileModal.module__active___Q3NVdz",
  "Qd": "UserProfileModal.module__mutualItemIconFrame___Q3NVdz",
  "D9": "UserProfileModal.module__mutualFriendInfo___Q3NVdz",
  "eV": "UserProfileModal.module__mutualFriendName___Q3NVdz",
  "zD": "UserProfileModal.module__mutualFriendUsername___Q3NVdz",
  "p$": "UserProfileModal.module__emptyState___Q3NVdz",
  "Ny": "UserProfileModal.module__mutualGuildIcon___Q3NVdz",
  "me": "UserProfileModal.module__separator___Q3NVdz",
  "AI": "UserProfileModal.module__emptyStateIcon___Q3NVdz",
};

module.exports = exports;
